import React, { useState } from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import InfoSection from '../InfoSection';
import { Button } from '../ButtonElements';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from '../HeroSection/HeroElements';
import { homeObjOne, homeObjTwo, homeObjThree } from './SEOData';
import seoVideo from '../../videos/SEO.mp4';

const SEOPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroContainer id="seo-home">
        <HeroBg>
          <VideoBg playsInline autoPlay loop muted src={seoVideo} type="video/mp4" />
        </HeroBg>
        <HeroContent>
          <HeroH1>
            Search Engine Optimization
            <br />
            Get your product to the top of all searches
          </HeroH1>
          <HeroP>
            Wiry specializes in ranking your website at the top of searches so that your product gets
            enough exposure and traffic, resulting in lead generation with top listing.
          </HeroP>
          <HeroBtnWrapper>
            <Button
              to="googlesearch"
              smooth
              duration={500}
              spy
              offset={-80}
              primary
              dark
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              Learn More {hover ? <ArrowForward /> : <ArrowRight />}
            </Button>
          </HeroBtnWrapper>
        </HeroContent>
      </HeroContainer>
      <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjTwo} />
      <InfoSection {...homeObjThree} />
      <Footer />
    </>
  );
};

export default SEOPage;
